import { __awaiter, __generator, __read, __values } from "tslib";
import { createContext } from './query-job';
import { getKeyByPath, isKey, SortOrder } from '@tencent/memoire-core';
import { OrderByKeyError } from '../../error';
var QueryJobSort = /** @class */ (function () {
    function QueryJobSort(node, parent) {
        this.node = node;
        this.parent = parent;
        this.context = createContext(node);
    }
    QueryJobSort.prototype.perform = function (output) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, comparer, keyPath, order, _b, _c, pointers;
            var e_1, _d;
            var _this = this;
            return __generator(this, function (_e) {
                _a = this.node, comparer = _a.comparer, keyPath = _a.path, order = _a.order;
                try {
                    for (_b = __values(this.context.inputs), _c = _b.next(); !_c.done; _c = _b.next()) {
                        pointers = _c.value;
                        pointers.sort(function (_a, _b) {
                            var _c = __read(_a, 2), x = _c[1];
                            var _d = __read(_b, 2), y = _d[1];
                            var valueX = getKeyByPath(x, keyPath);
                            var valueY = getKeyByPath(y, keyPath);
                            var cmp = _this.getComparerByType(comparer, order);
                            if (isKey(valueX) && isKey(valueY)) {
                                return cmp(valueX, valueY);
                            }
                            throw new OrderByKeyError();
                        });
                        output.push(pointers);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return [2 /*return*/];
            });
        });
    };
    QueryJobSort.prototype.getComparerByType = function (comparer, orderType) {
        if (orderType === SortOrder.ASCENDING) {
            return function (x, y) { return comparer.cmp(x, y); };
        }
        return function (x, y) { return -comparer.cmp(x, y); };
    };
    return QueryJobSort;
}());
export { QueryJobSort };
export default QueryJobSort;
//# sourceMappingURL=query-job-sort.js.map